import { render, staticRenderFns } from "./InventoryRecords.vue?vue&type=template&id=a1e6891a&scoped=true"
import script from "./InventoryRecords.vue?vue&type=script&lang=js"
export * from "./InventoryRecords.vue?vue&type=script&lang=js"
import style0 from "./InventoryRecords.vue?vue&type=style&index=0&id=a1e6891a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e6891a",
  null
  
)

export default component.exports